export default "__VITE_ASSET__COKz0hCC__"